export default __webpack_public_path__ + "static/media/next-active.c29d49eb.svg";